@if (isError) {
  <div class="container-fluid">
    <h1>Error:</h1>
    <h3>{{error}}</h3>
  </div>
}

@if (customer) {
  <div class="detail-page">
   <div class="detail-content">
    <div class="customer-header">
      <span class="customer-name">{{customer.first_name}} {{customer.last_name}}</span>
      <span class="ccid-badge">CCID: {{customer.ccid}}</span>
    </div>

    <div class="card">
      <div class="card-header">Customer Details</div>
      <div class="field-grid">
        <div class="field">
          <div class="field-label">First Name</div>
          <div class="field-value" [class.empty]="isEmpty(customer.first_name)">{{displayValue(customer.first_name)}}</div>
        </div>
        <div class="field">
          <div class="field-label">Last Name</div>
          <div class="field-value" [class.empty]="isEmpty(customer.last_name)">{{displayValue(customer.last_name)}}</div>
        </div>
        <div class="field">
          <div class="field-label">DOB</div>
          <div class="field-value" [class.empty]="isEmpty(customer.date_of_birth)">{{displayValue(customer.date_of_birth)}}</div>
        </div>
        <div class="field">
          <div class="field-label">SSN Last 4</div>
          <div class="field-value" [class.empty]="isEmpty(customer.ssn_last4)">{{displayValue(customer.ssn_last4)}}</div>
        </div>
        <div class="field">
          <div class="field-label">First Postal Code</div>
          <div class="field-value" [class.empty]="isEmpty(customer.addresses[0]?.postal_code)">{{displayValue(customer.addresses[0]?.postal_code)}}</div>
        </div>
        <div class="field">
          <div class="field-label">Customer ID</div>
          <div class="field-value" [class.empty]="isEmpty(customer.id)">{{displayValue(customer.id)}}</div>
        </div>
        <div class="field">
          <div class="field-label">Customer CCID</div>
          <div class="field-value" [class.empty]="isEmpty(customer.ccid)">{{displayValue(customer.ccid)}}</div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header">Product Group Details</div>
      <div class="field-grid">
        <div class="field">
          <div class="field-label">Client ID</div>
          <div class="field-value" [class.empty]="isEmpty(customer.client_id)">{{displayValue(customer.client_id)}}</div>
        </div>
        <div class="field">
          <div class="field-label">Product Group</div>
          <div class="field-value" [class.empty]="isEmpty(customer.product_group_id)">{{displayValue(customer.product_group_id)}}</div>
        </div>
        @if (customerDetails?.account_detail?.product_group_name) {
          <div class="field">
            <div class="field-label">Product Group {{newFeed.enabled ? 'Feed' : 'Wire'}} Display Name</div>
            <div class="field-value">{{customerDetails.account_detail.product_group_name}}</div>
          </div>
        }
        @if (customerDetails?.account_detail?.product_group_internal_name) {
          <div class="field">
            <div class="field-label">Product Group Internal Name</div>
            <div class="field-value">{{customerDetails.account_detail.product_group_internal_name}}</div>
          </div>
        }
      </div>
    </div>

    @if (languagePreference || extFields.length) {
      <div class="card">
        <div class="card-header">EXT Fields</div>
        <div class="card-body">
          @if (languagePreference) {
            <div class="lang-callout">
              <div class="lang-icon"><i class="fa-solid fa-language"></i></div>
              <div class="lang-text">
                <div class="lang-label">EXT+ Language Preference</div>
                <div class="lang-value">{{languagePreference}} <span class="lang-code">{{languageCode}}</span></div>
              </div>
              <div class="lang-note">Preferred for all communications</div>
            </div>
          }
          @if (extFields.length) {
            <div class="field-grid">
              @for (field of extFields; track field.key) {
                <div class="field">
                  <div class="field-label">{{field.key}}</div>
                  <div class="field-value">{{field.value}}</div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }

    <div class="card">
      <div class="card-header">Record Details</div>
      <div class="field-grid">
        <div class="field">
          <div class="field-label">Created At</div>
          <div class="field-value">{{customer.created_at}}</div>
        </div>
        <div class="field">
          <div class="field-label">Created By</div>
          <div class="field-value empty">Not returned</div>
        </div>
        <div class="field">
          <div class="field-label">Created By Name</div>
          <div class="field-value empty">Not returned</div>
        </div>
        <div class="field">
          <div class="field-label">Updated At</div>
          <div class="field-value">{{customer.updated_at}}</div>
        </div>
        <div class="field">
          <div class="field-label">Updated By</div>
          <div class="field-value empty">Not returned</div>
        </div>
        <div class="field">
          <div class="field-label">Updated By Name</div>
          <div class="field-value empty">Not returned</div>
        </div>
        <div class="field">
          <div class="field-label">Deactivation Status</div>
          <div class="field-value" [class.empty]="isEmpty(customerDetails?.account_detail?.disabled)">{{displayValue(customerDetails?.account_detail?.disabled)}}</div>
        </div>
      </div>
    </div>

    @if (!customerDetails) {
      <div class="card">
        <div class="card-header">Customer Details</div>
        <div class="card-body no-details">No customer details available</div>
      </div>
    }
    @if (customerDetails) {
      <div class="card history-card">
        <div class="card-header">Account History</div>
        <div class="history-grid cols-4 history-header-row">
          <div class="history-cell history-head">Client Source</div>
          <div class="history-cell history-head">Portal User ID</div>
          <div class="history-cell history-head">Source</div>
          <div class="history-cell history-head">Updated At</div>
        </div>
        @for (accountHistory of customerDetails.account_activity.history; track accountHistory) {
          <div class="history-grid cols-4">
            <div class="history-cell" [class.empty]="!accountHistory.client_source">{{accountHistory.client_source || '—'}}</div>
            <div class="history-cell" [class.empty]="!accountHistory.portal_user_id">{{accountHistory.portal_user_id || '—'}}</div>
            <div class="history-cell" [class.empty]="!accountHistory.source">{{accountHistory.source || '—'}}</div>
            <div class="history-cell" [class.empty]="!accountHistory.updated_at">{{(accountHistory.updated_at | date:'short') || '—'}}</div>
          </div>
        }
      </div>

      @for (consent of customerDetails?.notification_channel_detail; track consent) {
        <div class="card history-card">
          <div class="card-header">Consent History - {{consent.channel_addr}}</div>
          <div class="history-grid cols-4 history-header-row">
            <div class="history-cell history-head">Consent Type</div>
            <div class="history-cell history-head">Updated At</div>
            <div class="history-cell history-head">Source</div>
            <div class="history-cell history-head">Client Source</div>
          </div>
          @for (history of consent.history; track history) {
            <div class="history-grid cols-4">
              <div class="history-cell" [class.empty]="!history.type">{{history.type || '—'}}</div>
              <div class="history-cell" [class.empty]="!history.updated_at">{{(history.updated_at | date:'short') || '—'}}</div>
              <div class="history-cell" [class.empty]="!history.source">{{history.source || '—'}}</div>
              <div class="history-cell" [class.empty]="!history.client_source">{{history.client_source || '—'}}</div>
            </div>
          }
        </div>
      }

      <div class="card history-card">
        <div class="card-header">Notification Channel</div>
        <div class="history-grid cols-5 history-header-row">
          <div class="history-cell history-head">Channel Address</div>
          <div class="history-cell history-head">Channel Type</div>
          <div class="history-cell history-head">Consent Type</div>
          <div class="history-cell history-head">Updated At</div>
          <div class="history-cell history-head">Removed</div>
        </div>
        @for (notification of customerDetails?.notification_channel_detail; track notification) {
          <div class="history-grid cols-5">
            <div class="history-cell" [class.empty]="!notification.channel_addr">{{notification.channel_addr || '—'}}</div>
            <div class="history-cell" [class.empty]="!notification.channel_type">{{notification.channel_type || '—'}}</div>
            <div class="history-cell" [class.empty]="!notification.consent_latest?.type">{{notification.consent_latest?.type || '—'}}</div>
            <div class="history-cell" [class.empty]="!notification.consent_latest?.updated_at">{{(notification.consent_latest?.updated_at | date: 'shortDate') || '—'}}</div>
            <div class="history-cell" [class.empty]="notification?.removed_from_account == null">{{notification?.removed_from_account ?? '—'}}</div>
          </div>
        }
      </div>
    }
   </div>
  </div>
}


@if (!!customerMessages) {
  <div class="container-fluid list">
    <h1>Wire Messages</h1>
    <div class="row colhdrs">
      <div class="colw colw-15">
        <span>Date/Time (attempted)</span>
      </div>
      <div class="colw colw-15">
        <span>Message ID</span>
      </div>
      <div class="colw colw-15">
        <span>Experience ID</span>
      </div>
      <div class="colw colw-10">
        <span>Experience Name</span>
      </div>
      <div class="colw colw-10">
        <span>Experience Campaign</span>
      </div>
      <div class="colw colw-10">
        <span>Wire Message Text</span>
      </div>
    </div>
    @for (message of customerMessages; track message; let i = $index) {
      <div
        [ngClass]="{'message-selected' : messageDetails.indexOf(message.message_id) > -1}">
        <div class="row message" (click)="onMessageRowClick(message.message_id)">
          <div class="colw colw-15">
            <span>{{message.wire_msg_attempted_ts | date:'short'}}</span>
          </div>
          <div class="colw colw-15">
            <span>{{message.message_id}}</span>
          </div>
          <div class="colw colw-15">
            <span>{{message.journey_id}}</span>
          </div>
          <div class="colw colw-10">
            <span>{{message.journey_name}}</span>
          </div>
          <div class="colw colw-10">
            <span>{{message.journey_campaign}}</span>
          </div>
          <div class="colw colw-15">
            <span>{{message.wire_text}}</span>
          </div>
        </div>
        @if (messageDetails.indexOf(message.message_id) > -1) {
          <div class="row">
            <div class="row">
              <h3>Raw Message</h3>
              <div class="message-raw">
                {{message | json}}
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
}

@if (!!customerNotifications) {
  <div class="container-fluid list">
    <h1>Channel Notifications</h1>
    <div class="row colhdrs">
      <div class="colw colw-15">
        <span>Date/Time</span>
      </div>
      <div class="colw colw-15">
        <span>Channel</span>
      </div>
      <div class="colw colw-15">
        <span>Message ID</span>
      </div>
      <div class="colw colw-15">
        <span>Experience ID</span>
      </div>
      <div class="colw colw-15">
        <span>Experience Name</span>
      </div>
      <div class="colw colw-15">
        <span>Experience Campaign</span>
      </div>
    </div>
    @for (notification of customerNotifications; track notification; let i = $index) {
      <div
        [ngClass]="{'message-selected' : customerNotifications.indexOf(notification.message_id) > -1}">
        <div class="row message" (click)="onNotificationRowClick(notification.message_id)">
          <div class="colw colw-15">
            <span>{{notification.notification_sms_attempted_ts | date:'short'}}</span>
          </div>
          <div class="colw colw-15">
            <span>{{notification.notification_sms_attempted?.payload.channel_addr}}</span>
          </div>
          <div class="colw colw-15">
            <span>{{notification.message_id}}</span>
          </div>
          <div class="colw colw-15">
            <span>{{notification.journey_id}}</span>
          </div>
          <div class="colw colw-15">
            <span>{{notification.journey_name}}</span>
          </div>
          <div class="colw colw-15">
            <span>{{notification.journey_campaign}}</span>
          </div>
        </div>
        @if (notificationDetails.indexOf(notification.message_id) > -1) {
          <div class="row">
            <h3>Raw Message</h3>
            <div class="message-raw">
              {{notification | json}}
            </div>
          </div>
        }
      </div>
    }
  </div>
}
